import { FlexibleHeading as Heading, Spacing } from '@big-red-group/storefront-common-ui'
import { ItemHeading, ItemWrapper } from './BookingStep.styles'

const VoucherSelectorItem: React.FC<{ heading?: string; children: React.ReactNode; skeleton?: boolean }> = ({
  heading,
  children,
  skeleton,
}) => {
  if (skeleton) {
    return (
      <ItemWrapper active={false} skeleton>
        <ItemHeading completed={false}>
          <Heading size="XXS" color="text-primary-light" weight="bold" dataTestId="booking-step-title">
            {heading}
          </Heading>
        </ItemHeading>
      </ItemWrapper>
    )
  }

  return (
    <ItemWrapper active>
      {heading && (
        <>
          <ItemHeading completed>
            <Heading size="XXS" weight="bold" dataTestId="booking-step-title">
              {heading}
            </Heading>
          </ItemHeading>
          <Spacing size="S" />
        </>
      )}
      <Spacing size="XXS" />
      {children}
    </ItemWrapper>
  )
}

export default VoucherSelectorItem
